import { config } from '../config'

const EnvironmentBanner = () => {
  // Show prominent banner in dev stage only
  if (config.isDevStage) {
    // Use the actual build number from the build process
    const buildNumber = config.debug.buildNumber || 'Unknown'
    
    return (
      <div className="bg-yellow-400 text-yellow-900 px-4 py-3 text-center font-bold text-base border-b-2 border-yellow-600">
        🚧 DEVELOPMENT ENVIRONMENT - dev.youwont.xyz 🚧
        <br />
        <span className="text-sm font-normal">
          This is a development/staging environment for testing purposes
        </span>
        <br />
        <span className="text-xs font-normal">
          Build: {buildNumber}
        </span>
      </div>
    )
  }

  // No banner in production - return null for clean appearance
  if (config.isProdStage) {
    return null
  }

  // Fallback for unknown environment
  return (
    <div className="bg-gray-100 text-gray-800 px-4 py-2 text-center text-sm border-b border-gray-300">
      ⚠️ UNKNOWN ENVIRONMENT - {config.debug.viteStage || 'undefined'}
    </div>
  )
}

export default EnvironmentBanner
